// extracted by mini-css-extract-plugin
export default {"heading":"heading-aJx_F","tag":"tag-OTZLT","label":"label-jOUvS"};